/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-constant-condition */
import { App as AntApp, ConfigProvider } from "antd";
import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";
import type { TUserRoles } from "./app/app.constants";
import AuthGuard from "./components/AuthGuard";
import useAppBoot from "./hooks/useAppBoot";
import useAuth from "./hooks/useAuth";
import Loader from "./pages/Loader";
import NotFound from "./pages/NotFound";
import { APP_ROUTES, PUBLIC_ROUTES } from "./routes/routes";
import { antdTheme } from "./theme/theme";
import { filterRoutesByRole, flattenRoutes } from "./utils/global.utils";

const App = () => {
  const { role } = useAuth();
  const { loading } = useAppBoot();

  const accessibleRoutes = filterRoutesByRole(APP_ROUTES, role as TUserRoles);
  const flatRoutes = flattenRoutes(accessibleRoutes);

  return (
    <ConfigProvider theme={antdTheme}>
      <AntApp>
        {loading ? (
          <Loader />
        ) : (
          <Routes>
            {/* <Route path="/" element={<Navigate to={navigateUrl} />} />
            <Route path="/admin" element={<Navigate to={navigateUrl} />} />
            <Route path="/dashboard" element={<Navigate to={navigateUrl} />} /> */}
            <Route path="/" element={<Navigate to={"/admin/dashboard"} />} />
            <Route
              path="/admin"
              element={<Navigate to={"/admin/dashboard"} />}
            />
            <Route
              path="/dashboard"
              element={<Navigate to={"/admin/dashboard"} />}
            />

            {/* Private routers */}
            {flatRoutes.map(({ path, element: Element, roles }, idx) => (
              <Route
                path={path}
                key={idx + path}
                element={
                  <AuthGuard roles={roles}>
                    {Element ? (
                      <Suspense fallback={<Loader />}>
                        <Element />
                      </Suspense>
                    ) : (
                      <NotFound />
                    )}
                  </AuthGuard>
                }
              />
            ))}

            {/* Public routers */}
            {PUBLIC_ROUTES.map(({ path, element: Element }, idx) => (
              <Route
                path={path}
                key={idx + path}
                element={
                  <Suspense fallback={<Loader />}>
                    <Element />
                  </Suspense>
                }
              />
            ))}
          </Routes>
        )}
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
